import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../../../auth/services/auth.service';
import { AuthForm } from '../../../auth/types/auth-form.type';
import { OAuthSigninFormComponent } from '../../components/oauth-signin-form/oauth-signin-form.component';

@Component({
  selector: 'app-oauth-auth',
  standalone: true,
  imports: [CommonModule, TranslatePipe, OAuthSigninFormComponent],
  templateUrl: './oauth-auth.component.html',
  styleUrl: './oauth-auth.component.scss',
})
export class OAuthAuthComponent {
  #authService = inject(AuthService);

  isPending = computed(() => this.#authService.signin.isPending());

  handleSignin(form: AuthForm): void {
    void this.#authService.signin.mutateAsync({ form, layout: 'oauth' });
  }
}
